import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { SocialShare } from "core/classes/socialshare/social.share.class.js";

class TwitterShare extends Class {

	constructor(options) {
		super();
		this.$body = $(document.body);
		this.setUpEvents();
	}
	
	setUpEvents() {
		var self = this;
		this.$body.on('click', 'a[data-twitter-share]', function(){
			self.buildEndpointUrl(this);
		});
	}

	buildEndpointUrl(el) {
		var $el = $(el);
		var pubid = window.addthis_config.pubid;
		var pageUrl = "&url=" + $el.attr('data-share-url');
		var title = "&title=" + $el.attr('data-share-title').replace(/\&quot;/g,'"');

		var url =  "http://api.addthis.com/oexchange/0.8/forward/twitter/offer?pubid=" + pubid + pageUrl + title + "&ct=1";
		SocialShare.openWindow(url, "Twitter");
	}

} 

export { TwitterShare };



// WEBPACK FOOTER //
// ./Javascript/core/classes/socialshare/twitter.share.class.js